import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SettingsProjectsChecklistGroupFormComponent } from '../../../components/settings-projects-checklist-group-form/settings-projects-checklist-group-form.component';
import { SavedDataInfo } from 'src/app/models/form/saved-data-info';
import { ProjectsService } from 'src/app/services/api/projects.service';
import { AlertNotificationService } from 'src/app/services/alert-notification.service';

@Component({
  selector: 'app-projects-checklist-group-edit-page',
  imports: [SettingsProjectsChecklistGroupFormComponent],
  templateUrl: './projects-checklist-group-edit-page.component.html',
  styleUrl: './projects-checklist-group-edit-page.component.scss'
})
export class ProjectsChecklistGroupEditPageComponent implements OnInit {
  checklistGroupId!: number;
  checklistGroup?: any;

  constructor(
    private route: ActivatedRoute,
    private projectsService: ProjectsService,
    private alertNotificationService: AlertNotificationService
  ) {}

  ngOnInit(): void {
    this.checklistGroupId = Number(this.route.snapshot.paramMap.get('checklistGroupId'));
    if (this.checklistGroupId) {
      this.loadData(this.checklistGroupId);
    }
  }

  loadData(checklistGroupId: number): void {
    this.projectsService.detailSettingsChecklistGroup(checklistGroupId).subscribe((response: any) => {
      if (response?.data?.checklistGroup) {
        this.checklistGroup = response.data.checklistGroup;
      }
    });
  }

  onFormSavedData(savedDataInfo: SavedDataInfo): void {
    if (savedDataInfo.success) {
      this.alertNotificationService.success('Checklist Group saved successfully.');
    }
  }
}
